import React from "react";
import { isMobile } from "react-device-detect";
import Modal from "react-modal";
import { AccordionBanner } from "../accordion/AccordionBanner";

export const CookieModal = ({
  visible,
  closeModal,
}: {
  visible: boolean;
  closeModal: () => void;
}) => {
  return (
    <Modal isOpen={visible} style={customStyles}>
      <div
        className=""
        style={{
          border: "0px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="modal-header" style={{ position: "relative" }}>
          <div className="row" style={{ flex: 1 }}>
            <div className="col-xs-12 col-md-11">
              <h5 className="text-left font-weight-bold">
                Definições de cookies
              </h5>
              <h6 className="text-left">Lei Geral de Proteção de Dados</h6>
            </div>
            <div className="col-xs-12 col-md-1">
              <button type="button" className="close" onClick={closeModal}>
                <span aria-hidden="true">&times;</span>
                <span className="sr-only">Fechar</span>
              </button>
            </div>
          </div>
        </div>

        <div
          className="modal-body"
          style={{ overflow: "auto", position: "relative" }}
        >
          <div>
            <div className="text-center">
              <h6 className="text-left font-weight-bold">O que são cookies?</h6>
            </div>

            <p className="text-left">{oQueSao}</p>

            <p className="text-left">{oQueSao2}</p>
            <AccordionBanner
              title={"Cookies Primarios"}
              children={
                <>
                  <p className="text-left">{cookiesPrimarios}</p>
                  <br />
                  <div style={fundoTransparente}>
                    <p className="text-left">Persistentes</p>
                    <p className="text-left">{persistente}</p>
                  </div>
                  <div style={fundoCinza}>
                    <p className="text-left">Finalidade</p>
                    <p className="text-left">{primPersFinalidade}</p>
                  </div>
                </>
              }
            ></AccordionBanner>
            <AccordionBanner
              title={"Cookies de Terceiros"}
              children={
                <>
                  <p className="text-left">{cookiesTerceiros}</p>
                  <br />
                  <div style={fundoTransparente}>
                    <p className="text-left">Persistentes</p>
                    <p className="text-left">{persistente}</p>
                  </div>
                  <div style={fundoCinza}>
                    <p className="text-left">Finalidade</p>
                    <p className="text-left">{tercFinalidade}</p>
                  </div>
                </>
              }
            ></AccordionBanner>
            <p className="text-left">{desabilitar}</p>
            <div style={links}>
              <div style={navegadores}>
                <a
                  className="text-left"
                  href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=pt-BR"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Chrome
                </a>
              </div>
              <div style={navegadores}>
                <a
                  className="text-left"
                  href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Firefox
                </a>
              </div>
              <div style={navegadores}>
                <a
                  className="text-left"
                  href="https://support.microsoft.com/pt-br/help/4027947/microsoft-edge-delete-cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Microsoft Edge
                </a>
              </div>
              <div style={navegadores}>
                <a
                  className="text-left"
                  href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Internet Explorer
                </a>
              </div>
            </div>
            <p className="text-left">{maisInformacoes}</p>
            <div style={{ ...links, paddingBottom: 70 }}>
              <div style={navegadores}>
                <a
                  className="text-left"
                  href="https://support.google.com/analytics/answer/6004245?hl=pt-BR&ref_topic=2919631"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Google Analytics
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const oQueSao =
  "Cookies são arquivos salvos em seu computador, tablet ou telefone quando você visita um site. Usamos os cookies necessários para fazer o site funcionar da melhor forma possível e sempre aprimorar os nossos serviços. ";
const oQueSao2 =
  "Alguns cookies são classificados como necessários e permitem as funcionalidades centrais, como segurança, gerenciamento de rede e acessibilidade. Esses cookies podem ser coletados e armazenados assim que você inicia sua navegação ou quando usa algum recurso que os requer.";
const cookiesPrimarios =
  "Alguns cookies serão colocados em seu dispositivo diretamente pelo nosso site - são conhecidos como cookies primários. Eles são essenciais para você navegar no site e usar seus recursos.";
const persistente =
  "Utilizamos também cookies persistentes que permanecem em seu disco rígido até que você os apague ou seu navegador o faça, dependendo da data de expiração do cookie. Todos os cookies persistentes têm uma data de expiração gravada em seu código, mas sua duração pode variar.";
const primPersFinalidade =
  "Coletam e armazenam a ciência sobre o uso de cookies no site.";
const cookiesTerceiros =
  "Outros cookies são colocados no seu dispositivo não pelo site que você está visitando, mas por terceiros, como, por exemplo, os sistemas analíticos.";
const tercFinalidade =
  "Coletam informações sobre como você usa o site, como as páginas que você visitou e os links em que clicou. Nenhuma dessas informações pode ser usada para identificá-lo. Seu único objetivo é possibilitar análises e melhorar as funções do site.";
const desabilitar =
  "Você pode desabilitá-los alterando as configurações do seu navegador, mas saiba que isso pode afetar o funcionamento do site.";
const maisInformacoes =
  "Caso queira mais informações sobre os cookies de terceiros acesse:";

const customStyles = {
  content: {
    top: "10%",
    left: isMobile ? "10%" : "30%",
    right: isMobile ? "10%" : "30%",
    bottom: "20%",
  },
  overlay: { zIndex: 1040 },
};
const fundoTransparente = {
  paddingTop: 10,
  paddingBottom: 10,
  paddingLeft: 10,
  paddingRight: 10,
};
const fundoCinza = {
  background: "#f5f5f5",
  paddingTop: 20,
  paddingBottom: 20,
  paddingLeft: 20,
  paddingRight: 20,
  marginLeft: 10,
  marginRight: 10,
};
const navegadores = {
  marginTop: 10,
  marginBottom: 10,
};
const links = { marginTop: 30, marginBottom: 30, marginLeft: 10 };
